import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';

// Redux
import { saveManagePackagesCountStatus } from './index';

// Api's
import { packingTrackingApi } from '../../api';
import { GetManagePackagesCountStatus } from './managePackagesCountStatusTypes';
import { QuoteResponseCount } from '@/main/models/response';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';
import { QuoteCountStatusRequest } from '@/main/models/request';
import { formatDateToISOString } from '@/main/services/utilsDate';

export function* getManagePackagesCountStatusSaga(action: GetManagePackagesCountStatus) {
  try {
    const request: QuoteCountStatusRequest = {
      ...action.payload.request,
      startDate: formatDateToISOString(action.payload.request.startDate),
      finalDate: formatDateToISOString(action.payload.request.finalDate)
    };
    const response: AxiosResponse<Result<QuoteResponseCount[]>> = yield call(
      packingTrackingApi.countPackageStatus,
      request
    );

    if (response.data.result) {
      yield put(saveManagePackagesCountStatus(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        saveManagePackagesCountStatus(null, true, resultError.messagesDataError)
      );
    }
  }
}

